import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { apiConfiguration } from '../app.config';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token: string | null = null;

  constructor(private http: HttpClient) {}

  getToken(): Observable<string> {
    return of("");
    /*if (this.token) {
      return of(this.token);
    }
  
     const { url, xApiKey, customerSecret } = apiConfiguration;
  
    const headers = new HttpHeaders({
      'x-api-key': xApiKey,
      'Content-Type': 'application/json'
    });
  
    const body = {
      grantType: 'client_credentials',
      customerAdditionalData: {
        customerSecret: customerSecret
      }
    };
  
    return this.http.post<{ code: string, data: { accessToken: string } }>(
      `${url}oauth2/v1/token`,
      body,
      { headers }
    ).pipe(
      map(response => {
        if (response.code === '201') {
          this.token = response.data.accessToken; 
          return this.token;
        } else {
          throw new Error('Error al obtener el token');
        }
      }),
      catchError(error => {
        console.error('Error obteniendo el token', error);
        throw error; 
      })
    ); */
  }
  
}
